import h from 'hyperscript';
import type { HyperScriptProps } from 'hyperscript';

export function createNameInput(props?: HyperScriptProps) {
  return h<HTMLInputElement>('input', {
    type: 'text',
    required: true,
    maxLength: 255,
    ...props,
  });
}
